import React from 'react';
import isEmpty from 'lodash/isEmpty';
import RelatedTile from '../bundles/RelatedTile';
import {
    SearchRelatedAuthor,
    SearchRelatedGenre,
    SearchRelatedNarrator,
    SearchRelatedPublisher
} from './SearchRelatedComponents';
import { SearchSidebarResponseOut } from '../../store/api';
import { SearchState } from '../../store/search/state';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly search: SearchState;
    readonly related?: SearchSidebarResponseOut;
    readonly onSearchRelatedClickResetSearch?: () => void;
    readonly shopLanguage: string | undefined;
};

export const SearchResultSidebar = ({
    related,
    onSearchRelatedClickResetSearch = () => {},
    search,
    shopLanguage
}: Props) => {
    const { t } = useTranslation();
    if (!related || isEmpty(related)) {
        return null;
    }

    const bundles = related.bundles ?? [];
    const authors = related.authors ?? [];
    const narrators = related.narrators ?? [];
    const genres = related.genres ?? [];
    const publishers = related.publishers ?? [];

    return (
        <div className="search-results-sidebar" data-displayname="SearchResultSidebar">
            {bundles.length > 0 ? (
                <div className="sidebarresult-bundles" data-displayname="SidebarResultBundles">
                    <h4>{t('menu.shop.loanFormat.curatedCollections')}</h4>
                    {bundles.map((bundle, i) => {
                        return (
                            <RelatedTile
                                key={`related-bundle-${bundle.bundleId}-${i}`}
                                bundle={bundle}
                                title={bundle.title}
                                showArrow={true}
                                containsText={true}
                                keyWord={search.q}
                            />
                        );
                    })}
                </div>
            ) : null}
            {authors.length > 0 ? (
                <div className="sidebarresult-authors content-wrap" data-displayname="SidebarResultAuthor">
                    <h4>{t('yourLocalContent.yourAuthors.authors')}</h4>
                    {authors.map((author, i) => {
                        return (
                            <SearchRelatedAuthor
                                key={`related-author-${author.id}-${i}`}
                                author={author}
                                onSearchRelatedClickResetSearch={onSearchRelatedClickResetSearch}
                                keyWord={search.q}
                                shopLanguage={shopLanguage}
                            />
                        );
                    })}
                </div>
            ) : null}
            {narrators.length > 0 ? (
                <div className="sidebarresult-narrators" data-displayname="SidebarResultNarrators">
                    <h4>{t('menu.shop.loanFormat.narrators')}</h4>
                    {narrators.map((narrator, i) => {
                        return (
                            <SearchRelatedNarrator
                                key={`related-narrator-${narrator.id}-${i}`}
                                narrator={narrator}
                                onSearchRelatedClickResetSearch={onSearchRelatedClickResetSearch}
                                keyWord={search.q}
                                shopLanguage={shopLanguage}
                            />
                        );
                    })}
                </div>
            ) : null}
            {genres.length > 0 ? (
                <div className="sidebarresult-genres" data-displayname="SidebarResultGenres">
                    <h4>{t('menu.shop.loanFormat.genres')}</h4>
                    {genres.map((genre, i) => {
                        return (
                            <SearchRelatedGenre
                                key={`related-genre-${genre.id}-${i}`}
                                genre={genre}
                                onSearchRelatedClickResetSearch={onSearchRelatedClickResetSearch}
                                keyWord={search.q}
                                shopLanguage={shopLanguage}
                            />
                        );
                    })}
                </div>
            ) : null}
            {publishers.length > 0 ? (
                <div className="sidebarresult-publishers" data-displayname="SidebarResultPublishers">
                    <h4>{t('menu.shop.loanFormat.publishers')}</h4>
                    {publishers.map((publisher, i) => {
                        return (
                            <SearchRelatedPublisher
                                key={`related-pubslisher-${publisher}-${i}`}
                                publisher={publisher}
                                onSearchRelatedClickResetSearch={onSearchRelatedClickResetSearch}
                                keyWord={search.q}
                                shopLanguage={shopLanguage}
                            />
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};
